export const SERVICES = {
  DRS: 'DRS',
  PERMIT: 'Permit'
};